import {
  sendEmail,
} from "@/common/functions";
import { createModuleResetter } from "@/helpers/utils";

import {
  SEND_EMAIL,
} from "../actions";
import { RESET_STORE } from "../mutations";

const getInitState = () => ({});

const getters = {};

const mutations = {
  [RESET_STORE]: createModuleResetter(getInitState),
};

const actions = {
  async [SEND_EMAIL](_, payload) {
    try {
      const { data } = await sendEmail({ ...payload });

      return { ...data };
    } catch (error) {
      return { isSuccess: false };
    }
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  actions,
  mutations,
  getters,
};
